<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
        <v-row dense>
    
            <v-col cols="12" xl="12">
              <v-card class="pa-2" outlined tile height="100%">
                <v-data-table
                :headers="headers"
                :items="fireDrills"
                sort-by="Date"
                sort-asc
                :loading="isLoading"
                loading-text="Loading Client's Fire Drills"
                :search="search"
                height="550"
                >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>Fire Drills</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        clearable
                        flat
                        solo-inverted
                        hide-details
                        prepend-inner-icon="search"
                        label="search"
                        class="desktop"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="75%">
                        <template v-slot:activator="{ on }" v-if="display">
                        <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()"
                            >
                            <v-icon left>add</v-icon>
                            Add Fire Drill</v-btn
                        >
                        </template>
                        <v-card>
                        <v-card-title style="background-color: #2b3990">
                            <span class="headline white--text">{{ titleForm  }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="3">
                                <!-- <v-menu
                                    offset-y
                                    min-width="290px"
                                    max-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="drillDate"
                                        label="Drill Date"
                                        v-on="on"
                                        prepend-icon="events"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="drillDate" scrollable></v-date-picker>
                                </v-menu> -->
                                <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="drillDate"
                                        label="Drill Date"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                    v-model="drillDate"
                                    no-title
                                    scrollable
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="menu = false"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu.save(date)"
                                    >
                                        OK
                                    </v-btn>
                                    </v-date-picker>
                                </v-menu>
                                </v-col>
                                 <v-col cols="12" sm="12" md="3">
                                    
                                    <v-text-field
                                        v-model="startTime"
                                        label="Drill Start Time"
                                        prepend-icon="schedule"
                                        
                                    ></v-text-field>
                                        
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                    <v-text-field
                                        label="Duration of the Drill (minutes)"
                                        v-model="duration"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                    <v-text-field
                                        label="Number of People Participating in the Drill"
                                        v-model="numberOfPeople"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" v-if="newFireDrill">
                                    <v-select 
                                        filled 
                                        :items="clients" 
                                        item-text="Name" 
                                        item-value="_id" 
                                        label="Clients that Attended" 
                                        multiple 
                                        v-model="newClients"
                                        @change="viewLog"
                                    ></v-select>
                                    
                                </v-col>
                            </v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <h3>All Clients Evacuated in 90 Seconds?</h3>
                                        <v-switch
                                            v-model="evacuated"
                                            label="Yes"
                                            value="Yes"
                                        ></v-switch>
                                        <v-switch
                                            v-model="evacuated"
                                            label="No"
                                            value="No"
                                        ></v-switch>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" v-if="evacuated=='No'">
                                    <v-textarea 
                                        v-model="evacuatedExplain" 
                                        outlined 
                                        label="Please Explain"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <h3>Client and Staff Meet at Designated Meeting Location?</h3>
                                    <v-switch
                                        v-model="location"
                                        label="Yes"
                                        value="Yes"
                                    ></v-switch>
                                    <v-switch
                                        v-model="location"
                                        label="No"
                                        value="No"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" v-if="location=='No'">
                                    <v-textarea 
                                        v-model="locationExplain"
                                        outlined
                                        label="Please Explain"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <h3>Staff Closed Doors in Area of (Hypothetical) Fire?</h3>
                                    <v-switch
                                        v-model="closedDoors"
                                        label="Yes"
                                        value="Yes"
                                    ></v-switch>
                                    <v-switch
                                        v-model="closedDoors"
                                        label="No"
                                        value="No"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" v-if="closedDoors=='No'">
                                    <v-textarea 
                                        v-model="closedDoorsExplain"
                                        outlined
                                        label="Please Explain"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <h3>Obstacles Were Faced During the Drill?</h3>
                                    <v-switch
                                        v-model="obstacles"
                                        label="Yes"
                                        value="Yes"
                                    ></v-switch>
                                    <v-switch
                                        v-model="obstacles"
                                        label="No"
                                        value="No"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" v-if="obstacles=='Yes'">
                                    <v-textarea 
                                        v-model="obstaclesExplain"
                                        outlined
                                        label="Please Explain"
                                    ></v-textarea>
                                </v-col>
                        
                                <v-col cols="12" sm="12" md="6">
                                    <h3>Staff Completed Head Count at Designated Meeting Location?</h3>
                                    <v-switch
                                        v-model="headCount"
                                        label="Yes"
                                        value="Yes"
                                    ></v-switch>
                                    <v-switch
                                        v-model="headCount"
                                        label="No"
                                        value="No"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" v-if="headCount=='No'">
                                    <v-textarea 
                                        v-model="headCountExplain"
                                        outlined
                                        label="Please Explain"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <h3>All Staff and Clients Participated?</h3>
                                    <v-switch
                                        v-model="allParticipation"
                                        label="Yes"
                                        value="Yes"
                                    ></v-switch>
                                    <v-switch
                                        v-model="allParticipation"
                                        label="No"
                                        value="No"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" v-if="allParticipation=='No'">
                                    <v-textarea 
                                        v-model="allParticipationExplain"
                                        outlined
                                        label="Please Explain"
                                    ></v-textarea>
                                </v-col>
                               
                                <v-col cols="12" sm="12" md="6">
                                    <h3>Fire Extinguishers Tagged and Current?</h3>
                                    <v-switch
                                        v-model="taggedCurrent"
                                        label="Yes"
                                        value="Yes"
                                    ></v-switch>
                                    <v-switch
                                        v-model="taggedCurrent"
                                        label="No"
                                        value="No"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" v-if="taggedCurrent=='No'">
                                    <v-textarea 
                                        v-model="taggedCurrentExplain"
                                        outlined
                                        label="Please Explain"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <h3>All Smoke Detectors in the House are Working</h3>
                                    <v-switch
                                        v-model="detectorsWorking"
                                        label="Yes"
                                        value="Yes"
                                    ></v-switch>
                                    <v-switch
                                        v-model="detectorsWorking"
                                        label="No"
                                        value="No"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" v-if="detectorsWorking=='No'">
                                    <v-textarea 
                                        v-model="detectorsWorkingExplain"
                                        outlined
                                        label="Please Explain"    
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <h3>Smoke Detectors are on Each Level of the Home</h3>
                                    <v-switch
                                        v-model="eachLevel"
                                        label="Yes"
                                        value="Yes"
                                    ></v-switch>
                                    <v-switch
                                        v-model="eachLevel"
                                        label="No"
                                        value="No"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" v-if="eachLevel=='No'">
                                    <v-textarea 
                                        v-model="eachLevelExplain"
                                        outlined
                                        label="Please Explain"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <h3>All Carbon Monoxide Detectors in Home are Working?</h3>
                                    <v-switch
                                        v-model="carbonMonoxide"
                                        label="Yes"
                                        value="Yes"
                                    ></v-switch>
                                    <v-switch
                                        v-model="carbonMonoxide"
                                        label="No"
                                        value="No"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" v-if="carbonMonoxide=='No'">
                                    <v-textarea 
                                        v-model="carbonMonoxideExplain"
                                        outlined
                                        label="Please Explain"    
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <h3>Carbon Monoxide Detector Found on Each Level of Home</h3>
                                    <v-switch
                                        v-model="carbonEachLevel"
                                        label="Yes"
                                        value="Yes"
                                    ></v-switch>
                                    <v-switch
                                        v-model="carbonEachLevel"
                                        label="No"
                                        value="No"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" v-if="carbonEachLevel=='No'">
                                    <v-textarea 
                                        v-model="carbonEachLevelExplain"
                                        outlined
                                        label="Please Explain"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-textarea 
                                        v-model="comments"
                                        outlined
                                        label="Additional Comments"
                                    ></v-textarea>
                                </v-col>

                                <v-col cols="12">
                                    <v-file-input   
                                        v-model="newDocument"                             
                                        class="pa-2"
                                        label="Select documents to upload"
                                        show-size
                                        filled
                                        multiple
                                        prepend-icon="mdi-camera"
                                        accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                        @change="fileSelected"
                                    
                                    >
                                        <template #selection="{ text, index }">
                                        <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                                        </template>
                                    </v-file-input>
                                    </v-col>

                                    <v-col cols="12" sm="12"
                                    v-for="doc in newDocument"
                                    :key="doc.awsLink"
                                    >
                                    <v-img
                                        max-height="380"
                                        max-width="450"
                                        :src="doc.awsLink"  
                                    ></v-img>
                                </v-col>

                                <v-col cols="12" sm="12" md="6">
                                    <v-checkbox
                                        v-model="signed"
                                        label="Staff Signature"
                                        outlined
                                        @click="addStaffSig()"
                                    ></v-checkbox>
                                    <v-text-field label="Signed By" v-model="newStaffSignature"></v-text-field>
                                </v-col>

                                
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="white--text" color="#259647" @click="addFireDrill()" v-if="newFireDrill">Save</v-btn
                            >
                            <v-btn color="blue darken-1" text @click="updateFireDrill()" v-if="editFireDrill">Update</v-btn
                            >
                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        </v-card-actions>
                        </v-card>
                    </v-dialog>
                    </v-toolbar>
                    <v-text-field
                      v-model="search"
                      clearable
                      flat
                      solo-inverted
                      hide-details
                      prepend-inner-icon="search"
                      label="search"
                      class="mobile ml-5 mr-5 mb-3 mt-3"
                    ></v-text-field>
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="viewFireDrill(item)">
                    mdi-eye
                    </v-icon>
                    <!-- <v-icon small class="mr-2" @click="editCode(item)">
                    mdi-pencil
                    </v-icon> -->
                    <v-icon small @click="deleteFireDrill(item)">
                    mdi-delete
                    </v-icon>
                    <!-- <v-icon small @click="addDeal(item)">
                    add
                    </v-icon> -->
                </template>
                <template v-slot:no-data>
                    <v-btn color="#2b3990" class="white--text" @click="getFireDrills()">Reset</v-btn>
                </template>
                </v-data-table>
              </v-card>
            </v-col>
        </v-row>
    <Foot/>
  </div>
</template>

<script>
import axios from 'axios'
import Foot from '@/components/Footer'
import moment from 'moment'

const url = require("../client_config/config").url;

export default {
  components: {
      Foot,
  },
  data: function() {
    return {
      headers: [
        {
          text: 'Drill Date',
          align: 'start',
          sortable: false,
          value: 'Date',
        },
        { text: "Client", value: "ClientID.Name" },
        { text: "Staff Signature", value: "StaffSignature" },
        { text: "Drill Start Time", value: "StartTime" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      dialog: false,
      editFireDrill: false,
      newFireDrill: false,
      msg: false,
      signed: false,
      search: "",
      text:"",
      fireDrills: [],
      tempData: [],
      codes: [],
      clients: [],
      newClients: [],
    //   clientID: this.$route.params.clientID,
      role: localStorage.getItem('userRole'),
      display: false,
      nav: true,
      newStaffSignature: "",
      staff: localStorage.getItem('Name'),
      titleForm: "New Fire Drill",
      fireDrillID: "",
      drillDate: moment(new Date()).format("YYYY-MM-DD"),
      evacuated: "",
      evacuatedExplain: "",
      location: "",
      locationExplain: "",
      closedDoors: "",
      closedDoorsExplain: "",
      obstacles: "",
      obstaclesExplain: "",
      headCount: "",
      headCountExplain: "",
      allParticipation: "",
      allParticipationExplain: "",
      startTime: "",
      duration: "",
      numberOfPeople: "",
      taggedCurrent: "",
      taggedCurrentExplain: "",
      detectorsWorking: "",
      detectorsWorkingExplain: "",
      eachLevel: "",
      eachLevelExplain: "",
      carbonMonoxide: "",
      carbonMonoxideExplain: "",
      carbonEachLevel: "",
      carbonEachLevelExplain: "",
      comments: "",
      newDocument: [],
      uploadFile: "",
      fireDrillForm: "",
      userState: localStorage.getItem('userState'),
      editedIndex: -1,
      editedItem: {
        DrillDate: "",
        Evacuated: "",
        EvacuatedExplain: "",
        Location: "",
        LocationExplain: "",
        ClosedDoors: "",
        ClosedDoorsExplain: "",
        Obstacles: "",
        ObstaclesExplain: "",
        HeadCount: "",
        HeadCountExplain: "",
        AllParticipation: "",
        AllParticipationExplain: "",
        StartTime: "",
        Duration: "",
        NumberOfPeople: "",
        TaggedCurrent: "",
        TaggedCurrentExplain: "",
        DetectorsWorking: "",
        DetectorsWorkingExplain: "",
        EachLevel: "",
        EachLevelExplain: "",
        CarbonMonoxide: "",
        CarbonMonoxideExplain: "",
        CarbonEachLevel: "",
        CarbonEachLevelExplain: "",
        Comments: "",
        StaffSignature: "",
        FireDrillForm: "",
      },
      defaultItem: {
        DrillDate: "",
        Evacuated: "",
        EvacuatedExplain: "",
        Location: "",
        LocationExplain: "",
        ClosedDoors: "",
        ClosedDoorsExplain: "",
        Obstacles: "",
        ObstaclesExplain: "",
        HeadCount: "",
        HeadCountExplain: "",
        AllParticipation: "",
        AllParticipationExplain: "",
        StartTime: "",
        Duration: "",
        NumberOfPeople: "",
        TaggedCurrent: "",
        TaggedCurrentExplain: "",
        DetectorsWorking: "",
        DetectorsWorkingExplain: "",
        EachLevel: "",
        EachLevelExplain: "",
        CarbonMonoxide: "",
        CarbonMonoxideExplain: "",
        CarbonEachLevel: "",
        CarbonEachLevelExplain: "",
        Comments: "",
        StaffSignature: "",
        FireDrillForm: "",
      },
      isLoading: true,
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.getFireDrills();
    this.checkRole();
    this.getClients();
  },

  methods: {
    initialize() {
      this.fireDrills = [];
    },
    viewFireDrill(item) {
        this.dialog = true;
        this.newFireDrill = false;
        this.editFireDrill = true;
        this.drillDate = moment(item.Date).format("YYYY-MM-DD");
        this.evacuated = item.Evacuated;
        this.evacuatedExplain = item.EvacuatedExplain;
        this.location = item.Location;
        this.locationExplain = item.LocationExplain;
        this.closedDoors = item.ClosedDoors;
        this.closedDoorsExplain = item.ClosedDoorsExplain;
        this.obstacles = item.Obstacles;
        this.obstaclesExplain = item.ObstaclesExplain;
        this.headCount = item.HeadCount;
        this.headCountExplain = item.HeadCountExplain;
        this.allParticipation = item.AllParticipation;
        this.allParticipationExplain = item.AllParticipationExplain;
        this.startTime = item.StartTime;
        this.duration = item.Duration;
        this.numberOfPeople = item.NumberOfPeople;
        this.taggedCurrent = item.TaggedCurrent;
        this.taggedCurrentExplain = item.TaggedCurrentExplain;
        this.detectorsWorking = item.DetectorsWorking;
        this.detectorsWorkingExplain = item.DetectorsWorkingExplain;
        this.eachLevel = item.EachLevel;
        this.eachLevelExplain = item.EachLevelExplain;
        this.carbonMonoxide = item.CarbonMonoxide;
        this.carbonMonoxideExplain = item.CarbonMonoxideExplain;
        this.carbonEachLevel = item.CarbonEachLevel;
        this.carbonEachLevelExplain = item.CarbonEachLevelExplain;
        this.comments = item.Comments;
        this.newStaffSignature = item.StaffSignature;
        this.fireDrillForm = item.FireDrillForm;
        if(item.documents.length > 0){
        const tempData = [];
        for(let i = 0; i < item.documents.length ; i++){
            tempData.push({
            name: item.documents[i].Name,
            awsLink: item.documents[i].AWSLink,
            });
            }
            this.newDocument = tempData;
        }
        this.fireDrillID= item._id;
    },
    showAdd() {
      this.titleForm= "New Fire Drill";
      this.newFireDrill = true;
      this.editFireDrill  = false;
    },

    deleteFireDrill(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this fire drill?") &&
      this.fireDrillDelete(id);

    },

    fireDrillDelete(id) {
      axios.delete(`${url}/fireDrill/${id}`)
      .then((response) => {
        this.getFireDrills();
        if (response.status == 400) {
          response.json().then(function(data) {
            return data.msg;
          });
        }
        this.msg=true;
        this.text="The fire drill has been deleted successfully.";
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.clearFields();
    },

    updateFireDrill() {
      var req_body = {
        Date: this.drillDate,
        Evacuated: this.evacuated,
        EvacuatedExplain: this.evacuatedExplain,
        Location: this.location,
        LocationExplain: this.locationExplain,
        ClosedDoors: this.closedDoors,
        ClosedDoorsExplain: this.closedDoorsExplain,
        Obstacles: this.obstacles,
        ObstaclesExplain: this.obstaclesExplain,
        HeadCount: this.headCount,
        HeadCountExplain: this.headCountExplain,
        AllParticipation: this.allParticipation,
        AllParticipationExplain: this.allParticipationExplain,
        StartTime: this.startTime,
        Duration: this.duration,
        NumberOfPeople: this.numberOfPeople,
        TaggedCurrent: this.taggedCurrent,
        TaggedCurrentExplain: this.taggedCurrentExplain,
        DetectorsWorking: this.detectorsWorking,
        DetectorsWorkingExplain: this.detectorsWorkingExplain,
        EachLevel: this.eachLevel,
        EachLevelExplain: this.eachLevelExplain,
        CarbonMonoxide: this.carbonMonoxide,
        CarbonMonoxideExplain: this.carbonMonoxideExplain,
        CarbonEachLevel: this.carbonEachLevel,
        CarbonEachLevelExplain: this.carbonEachLevelExplain,
        Comments: this.comments,
        StaffSignature: this.newStaffSignature,
        FireDrillForm: this.FireDrillForm,
      };
      axios.put(`${url}/fireDrill/${this.fireDrillID}`, req_body).then((response) => {
        this.getFireDrills();
        if (response.status == 400) {
          response.json().then(function(data) {
            alert(data.msg);
          });
        }
        this.msg =true;
        this.text ="The fire drill has been updated successfully.";
        
        if(this.uploadFile !== null && this.uploadFile !== undefined){
            this.saveFile()
        }
      });
    },

    getFireDrills: function() {
      this.isLoading = true;
      axios.get(`${url}/fireDrill`).then(res => {
        var temp = res.data.fireDrills;
       
        for(var k=0; k < temp.length; k++){
            if(temp[k].ClientID.State == this.userState){
                this.fireDrills.push(temp[k])
            }
        
      }
        
      }).finally(() => this.isLoading = false);
    },


    clearFields() {
        this.drillDate = "";
        this.evacuated = "";
        this.evacuatedExplain = "";
        this.location = "";
        this.locationExplain = "";
        this.closedDoors = "";
        this.closedDoorsExplain = "";
        this.obstacles = "";
        this.obstaclesExplain = "";
        this.headCount = "";
        this.headCountExplain = "";
        this.allParticipation = "";
        this.allParticipationExplain = "";
        this.startTime = "";
        this.duration = "";
        this.numberOfPeople = "";
        this.taggedCurrent = "";
        this.taggedCurrentExplain = "";
        this.detectorsWorking = "";
        this.detectorsWorkingExplain = "";
        this.eachLevel = "";
        this.eachLevelExplain = "";
        this.carbonMonoxide = "";
        this.carbonMonoxideExplain = "";
        this.carbonEachLevel = "";
        this.carbonEachLevelExplain = "";
        this.comments = "";
        this.newStaffSignature = "";
        this.fireDrillForm = "";
        this.newStaff = "";
        this.newDocument = [],
        this.signed = false
    },

    checkRole() {
        if (this.role == 'Administration' || 
        this.role == 'Program Manager' ||
        this.role == 'House Manager' ||
        this.role == 'Assistant Manager' ||
        this.role == 'Shift Lead' ||
        this.role == 'Program Coordinator' ||
        this.role == 'Client Services Manager' 
        
        ){
            this.display = true;
            this.nav = false;
        } 
    },

    getClients() {
      axios.get(`${url}/clients/state/${this.userState}`).then(async (res) => {
        this.clients = res.data.clients;
      });
    },

    addFireDrill: function() {
        this.newClients
        if (this.newClients.length >= 1){
            for (var i = 0; i < this.newClients.length; i++ ){
                var req_body = {
                Date: this.drillDate,
                Evacuated: this.evacuated,
                EvacuatedExplain: this.evacuatedExplain,
                Location: this.location,
                LocationExplain: this.locationExplain,
                ClosedDoors: this.closedDoors,
                ClosedDoorsExplain: this.closedDoorsExplain,
                Obstacles: this.obstacles,
                ObstaclesExplain: this.obstaclesExplain,
                HeadCount: this.headCount,
                HeadCountExplain: this.headCountExplain,
                AllParticipation: this.allParticipation,
                AllParticipationExplain: this.allParticipationExplain,
                StartTime: this.startTime,
                Duration: this.duration,
                NumberOfPeople: this.numberOfPeople,
                TaggedCurrent: this.taggedCurrent,
                TaggedCurrentExplain: this.taggedCurrentExplain,
                DetectorsWorking: this.detectorsWorking,
                DetectorsWorkingExplain: this.detectorsWorkingExplain,
                EachLevel: this.eachLevel,
                EachLevelExplain: this.eachLevelExplain,
                CarbonMonoxide: this.carbonMonoxide,
                CarbonMonoxideExplain: this.carbonMonoxideExplain,
                CarbonEachLevel: this.carbonEachLevel,
                CarbonEachLevelExplain: this.carbonEachLevelExplain,
                Comments: this.comments,
                StaffSignature: this.newStaffSignature,
                FireDrillForm: this.fireDrillForm,
                ClientID: this.newClients[i],
            };

        axios.post(`${url}/fireDrill`, req_body ).then(res => {
            this.getFireDrills();
            if (res.status == 400) {
            res.json().then(function(data) {
                this.text=data.msg;
            });
            }
            this.msg =true;
            this.text ="The fire drill info has been sent to selected clients.";
            if(this.uploadFile !== null && this.uploadFile !== undefined){
                this.fireDrillID = res.data._id

                this.saveFile()
            }
            
        });
       
        }
        this.close();

        } else {
            req_body = {
                Date: this.drillDate,
                Evacuated: this.evacuated,
                EvacuatedExplain: this.evacuatedExplain,
                Location: this.location,
                LocationExplain: this.locationExplain,
                ClosedDoors: this.closedDoors,
                ClosedDoorsExplain: this.closedDoorsExplain,
                Obstacles: this.obstacles,
                ObstaclesExplain: this.obstaclesExplain,
                HeadCount: this.headCount,
                HeadCountExplain: this.headCountExplain,
                AllParticipation: this.allParticipation,
                AllParticipationExplain: this.allParticipationExplain,
                StartTime: this.startTime,
                Duration: this.duration,
                NumberOfPeople: this.numberOfPeople,
                TaggedCurrent: this.taggedCurrent,
                TaggedCurrentExplain: this.taggedCurrentExplain,
                DetectorsWorking: this.detectorsWorking,
                DetectorsWorkingExplain: this.detectorsWorkingExplain,
                EachLevel: this.eachLevel,
                EachLevelExplain: this.eachLevelExplain,
                CarbonMonoxide: this.carbonMonoxide,
                CarbonMonoxideExplain: this.carbonMonoxideExplain,
                CarbonEachLevel: this.carbonEachLevel,
                CarbonEachLevelExplain: this.carbonEachLevelExplain,
                Comments: this.comments,
                StaffSignature: this.newStaffSignature,
                FireDrillForm: this.fireDrillForm,
                ClientID: this.newClients[i],
            };
            axios.post(`${url}/fireDrill`, req_body ).then(res => {
            this.getFireDrills();
            if (res.status == 400) {
            res.json().then(function(data) {
                this.text=data.msg;
            });
            }
            this.msg =true;
            this.text ="The fire drill info has been sent to selected clients.";
            if(this.uploadFile !== null && this.uploadFile !== undefined){
                this.fireDrillID = res.data._id

                this.saveFile()
            }
            
        });
       
        this.close();
        }
        },

        addStaffSig: function() {
            if(this.newStaffSignature == ""){
                this.newStaffSignature = this.staff + " - " + new Date();
            } else {
                this.newStaffSignature = ""
            }
      },

      fileSelected(e) {
          this.uploadFile=e;
        },

        saveFile() {
          this.message = "";
          for (let i = 0; i < this.uploadFile.length; i++) {
            this.uploadFiles(this.uploadFile[i]);
          }
        },

        uploadFiles(file) {
          const formData = new FormData();
          formData.append('fireDrill', file);
          var ct = { headers:{"content-type" : "multipart/form-data"}};
          axios.post(`${url}/fireDrill/fileuploader/${this.fireDrillID}/${this.clientID}`,formData, ct)
          .then(res => {
            if(res){
              this.getFireDrills();
            }
          })
          .catch(err => {
            console.log(err);
          });
        },

        deleteChip(index) {
          // Prompt here with text if required
          this.newDocument.splice(index, 1);
        },

        viewLog(){
            console.log(this.newClients)
        }

  },

};
</script>
